import { useTranslation } from 'react-i18next';
import React, { useCallback, useRef, useEffect, useMemo, useState } from 'react';
import './Container.less';
import Header from '../components/HeaderForPC';
import Footer from '../components/FooterForPC';
import BaseContainer from '../components/BaseContainer';
import { parseQuery } from '~/common/utils';
import { getTime } from '~/utils/getTime';
import { customRedirect } from '~/utils/link/goPage';
import { logDetail } from '~/utils/log';
import { getSpecFont, getSpecFontForNews } from '~/utils/fontClass/index';
import useAreaLimit from '~/common/hooks/useAreaLimit';
import DomainLimit from '~/components/domainLimit';
import { getNews, getNewsDetail } from '~/common/services/siteData';

export default function Container() {
  const { t, i18n } = useTranslation();
  const { isLimit } = useAreaLimit();
  const [newsDetail, setNewsDetail] = useState<any>({});
  const [newsList, setNewsList] = useState([]);
  const [filtedNews, setFiltedNews] = useState([]);
  const lock = useRef(false);

  const backNewsList = () => {
    customRedirect('./newslist');
  };

  const goDetail = (item) => {
    if (item.url) {
      customRedirect(item.url, true);
      return;
    }
    customRedirect(`./newsdetail?id=${item.id}`);
  };

  const browserAction = useCallback((item) => {
    try {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 300);
      history.replaceState({}, '', location.origin + location.pathname + '?id=' + item.id);
    } catch (_) {}
  }, []);

  const goPrev = async () => {
    if (!page.hasPrev) {
      return;
    }
    if (lock.current) {
      return;
    }
    lock.current = true;
    let index = filtedNews.findIndex((item) => item.id === newsDetail.id);
    let prev = filtedNews[index - 1];
    const data = await getNewsDetail({
      id: prev.id,
      language: i18n.language
    });
    setNewsDetail(data);
    browserAction(prev);
    setTimeout(() => {
      lock.current = false;
    }, 300);
  };
  const goNext = async () => {
    if (!page.hasNext) {
      return;
    }
    if (lock.current) {
      return;
    }
    lock.current = true;
    let index = filtedNews.findIndex((item) => item.id === newsDetail.id);
    let next = filtedNews[index + 1];
    const data = await getNewsDetail({
      id: next.id,
      language: i18n.language
    });
    setNewsDetail(data);
    browserAction(next);
    setTimeout(() => {
      lock.current = false;
    }, 300);
  };

  const page = useMemo(() => {
    let index = filtedNews.findIndex((item) => item.id === newsDetail.id);
    if (!newsDetail || filtedNews.length === 0 || index === -1) {
      return {
        hasPrev: false,
        hasNext: false
      };
    }
    return {
      hasPrev: index !== 0,
      hasNext: index !== filtedNews.length - 1
    };
  }, [filtedNews, newsDetail]);

  useEffect(() => {
    // 埋点上报
    const query = parseQuery();
    logDetail(`${query.id}`);

    const initNewsDetail = async () => {
      if (!query.id) {
        return;
      }
      const data = await getNewsDetail({
        id: query.id,
        language: i18n.language
      });
      setNewsDetail(data);
    };
    const initNewsList = async () => {
      const res = await getNews({ type: 'ALL', page: 1, size: 2000, language: i18n.language });
      let data = res.data;
      setNewsList(data);
      // 过滤外链新闻
      let filted = data.filter((item) => !item.url);
      setFiltedNews(filted);
    };
    initNewsDetail();
    initNewsList();
  }, []);

  if (isLimit) {
    return <DomainLimit />;
  }
  return (
    <BaseContainer>
      <Header />
      <div styleName="detail_contain_wrap">
        <div
          styleName="news_detail_contain"
          className={getSpecFontForNews(i18n.language, false)}
          dangerouslySetInnerHTML={{ __html: newsDetail?.content || '' }}
        ></div>
        <div styleName="news_detail_aside">
          <div styleName="aside_title" className={getSpecFont(i18n.language)}>
            {t('latest')}
          </div>
          {/* 列表循环 */}
          <div styleName="aside_list">
            {newsList.map((item, index) => {
              return (
                <div styleName="aside_data_wrap" key={index} onClick={() => goDetail(item)}>
                  <div styleName="aside_pic">
                    <img src={item?.image} alt="" />
                  </div>
                  <div styleName="latest_wrap">
                    <div styleName="latest_title">{item?.title}</div>
                    <div styleName="latest_date">
                      {getTime(item?.update_at * 1000, 'MM/dd/yyyy')}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div styleName="aside_btn" onClick={() => backNewsList()}>
            <span className={getSpecFont(i18n.language)}>{t('all_news')}</span>
          </div>
        </div>
      </div>
      <div styleName="change_news_contain">
        <div
          styleName="prev_news"
          className={getSpecFont(i18n.language)}
          style={{ filter: page.hasPrev ? '' : 'grayscale(100%)' }}
          onClick={goPrev}
        >
          <div styleName="arrow_left"></div>
          <span>{t('page_news_prev')}</span>
        </div>
        <div
          styleName="next_news"
          className={getSpecFont(i18n.language)}
          style={{ filter: page.hasNext ? '' : 'grayscale(100%)' }}
          onClick={goNext}
        >
          <span>{t('page_news_next')}</span>
          <div styleName="arrow_right"></div>
        </div>
      </div>
      <Footer customStyle={{}} />
    </BaseContainer>
  );
}
